import { createStore } from 'vuex'
import axios from 'axios'

const API_BASE_URL = 'http://localhost:8000/api'

export default createStore({
  state: {
    token: localStorage.getItem('token') || '',
    user: JSON.parse(localStorage.getItem('user') || 'null'),
    cities: [],
    tags: []
  },
  getters: {
    isLoggedIn: state => !!state.token,
    currentUser: state => state.user
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
      axios.defaults.headers.common['Authorization'] = `Token ${token}`
    },
    SET_USER(state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    CLEAR_AUTH(state) {
      state.token = ''
      state.user = null
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      delete axios.defaults.headers.common['Authorization']
    },
    SET_CITIES(state, cities) {
      state.cities = cities
    },
    SET_TAGS(state, tags) {
      state.tags = tags
    }
  },
  actions: {
    async login({ commit }, credentials) {
      try {
        const response = await axios.post(`${API_BASE_URL}/users/login/`, credentials)
        const { token, user } = response.data
        commit('SET_TOKEN', token)
        commit('SET_USER', user)
        return response.data
      } catch (error) {
        throw error
      }
    },
    async register({ commit }, userData) {
      try {
        const response = await axios.post(`${API_BASE_URL}/users/register/`, userData)
        return response.data
      } catch (error) {
        throw error
      }
    },
    logout({ commit }) {
      commit('CLEAR_AUTH')
    },
    async fetchCities({ commit }) {
      try {
        const response = await axios.get(`${API_BASE_URL}/spots/cities/`)
        commit('SET_CITIES', response.data)
      } catch (error) {
        console.error('获取城市列表失败:', error)
      }
    },
    async fetchTags({ commit }) {
      try {
        const response = await axios.get(`${API_BASE_URL}/spots/tags/`)
        commit('SET_TAGS', response.data)
      } catch (error) {
        console.error('获取标签列表失败:', error)
      }
    }
  }
})
